import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { CalendarSettingsType, UnionLocations, CalendarTypeUnion } from '../types';
import { getIndexByMonthname, getMonthnameByIndex } from '../utils/formatDateAndTime';

export interface TableDataType {
  date: Date,
}

export const currentDate = new Date();

class Calendar{
  areSettingsFetched = false;
  calendarSettings: CalendarSettingsType = {
    country: undefined,
    month: '',
    year: 0,
    calendarType: 'YEAR',
  };
  tableData: TableDataType = {
    date: currentDate,
  };

  getCalendarSettings = async () => {
    try {
      this.areSettingsFetched = false;
      this.calendarSettings = await apiConfig.calendarService.getSettings();
      this.tableData.date = new Date(this.calendarSettings.year, getIndexByMonthname(this.calendarSettings.month));
      this.areSettingsFetched = true;
    }
    catch (e) {
      this.areSettingsFetched = true;
    }
  };

  updateCalendarSettings = async (settings: CalendarSettingsType) => {
    try {
      this.calendarSettings = settings;
      await apiConfig.calendarService.updateSettings(settings);
    }
    catch (e) {
      this.calendarSettings = settings;
    }
  };

  updateCalendarCountry = (newCountry: UnionLocations) => {
    this.updateCalendarSettings({...this.calendarSettings, country: newCountry});
  };

  updateCalendarType = (newType: string) => {
    this.updateCalendarSettings({...this.calendarSettings, calendarType: (newType.toUpperCase() as CalendarTypeUnion)});
  };

  updateCalendarTableData = (tableData: TableDataType) => {
    this.tableData = tableData;
    this.updateCalendarSettings({...this.calendarSettings,
      year: tableData.date.getFullYear(),
      month: getMonthnameByIndex(tableData.date.getMonth())
    });
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export const CalendarStore = new Calendar();
